"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagManagerPreconnect = exports.TagManager = void 0;
const react_1 = __importDefault(require("react"));
const webapp_constants_1 = require("@eventbrite/webapp-constants");
const script_1 = __importDefault(require("next/script"));
const BASE = "https://www.googletagmanager.com/ns.html?id=";
const TagManager = ({ publicUserId, stage, environment }) => {
    const { production, qa, development } = environment;
    const PATHS = {
        PROD: `${BASE}${production.id}${production.query}`,
        QA: `${BASE}${qa.id}${qa.query}`,
        DEV: `${BASE}${qa.id}${development.query}`,
    };
    const QA_ENV_CONFIG = {
        path: PATHS.QA,
        ...qa,
    };
    const PROD_ENV_CONFIG = {
        path: PATHS.PROD,
        ...production,
    };
    const DEV_ENV_CONFIG = {
        path: PATHS.DEV,
        id: qa.id,
        query: development.query,
    };
    const ENV_CONFIG = {
        [webapp_constants_1.Stage.PROD]: PROD_ENV_CONFIG,
        [webapp_constants_1.Stage.PREPROD]: QA_ENV_CONFIG,
        [webapp_constants_1.Stage.TEST]: QA_ENV_CONFIG,
        [webapp_constants_1.Stage.LOCAL]: QA_ENV_CONFIG,
        [webapp_constants_1.Stage.DEV]: DEV_ENV_CONFIG,
    };
    const config = ENV_CONFIG[stage];
    return (react_1.default.createElement(script_1.default, { id: "tag-manager", dangerouslySetInnerHTML: {
            __html: `

          window.dataLayer = window.dataLayer || [];

          dataLayer.push({
            'dfaPartnerID': '32958c2d_8dd2264347c98d327138fc917a4ed24d',
            'publicUserID': '${publicUserId}'
          });

          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl+'${config.query}';f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${config.id}');

        `,
        } }));
};
exports.TagManager = TagManager;
const TagManagerPreconnect = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("link", { rel: "preconnect", href: "https://www.googletagmanager.com" }),
        react_1.default.createElement("link", { rel: "dns-prefetch", href: "https://www.googletagmanager.com" })));
};
exports.TagManagerPreconnect = TagManagerPreconnect;
//# sourceMappingURL=TagManager.js.map